import { ALERT, HIDE_ALERT } from '../constants'

const initialState = {
  klass: '',
  message: '',
  timeout: null,
  visible: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case ALERT:
      return {
        ...state,
        klass: action.klass,
        visible: true,
        timeout: action.timeout,
        message: action.message
      }
    case HIDE_ALERT:
      return {
        ...state,
        klass: '',
        message: '',
        timeout: null,
        visible: false
      }
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/alert.js